import { QRCodeSVG } from 'qrcode.react';

// Touchless-feedback QR bottom bar — "Scan with your phone".
//
// Shared by the main feedback view (App.js) and the service-request kiosk
// (ServiceRequestApp.js) so the markup/gating live in one place.
//
// Renders only when ALL hold:
//   - `refId` is present
//   - running inside the Android kiosk app (window.AndroidDevice injected) —
//     so it never shows in a plain browser
//   - the `touchlessFeedback` feature flag isn't explicitly disabled
//     (default ON, same convention as occupancy/swaasScoreGauge)
//   - `visible` (caller-supplied context gate, e.g. home screen only)
export default function TouchlessQR({ refId, config = {}, features = {}, serviceDeskMode, visible = true }) {
  if (!visible || !refId) return null;
  if (typeof window.AndroidDevice?.getAssetId !== 'function') return null;

  const enabled = (features?.touchlessFeedback ?? config?.features?.touchlessFeedback) !== false;
  if (!enabled) return null;

  // Title follows the mode: the service-request kiosk reports issues ("Request"),
  // the main view collects ratings ("Feedback").
  const title = serviceDeskMode === 'service-request' ? 'Touchless Request' : 'Touchless Feedback';

  const value = config.public_feedback_url
    ? `${config.public_feedback_url}/?refId=${encodeURIComponent(refId)}`
    : window.location.href;

  return (
    <div className="qr-bottom-bar">
      <QRCodeSVG
        value={value}
        size={80}
        level="M"
        includeMargin={false}
        bgColor="#ffffff"
        fgColor="#1e293b"
      />
      <div className="qr-bottom-bar-text">
        <span className="qr-bottom-bar-title">{title}</span>
        <span className="qr-bottom-bar-desc">Scan with your phone</span>
      </div>
    </div>
  );
}
